/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  InvitationCreatedOut,
  ListResidentsParams,
  PaginatedResidentListOut,
  ResidentIn,
  ResidentOut
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listResidentsResponse200 = {
  data: PaginatedResidentListOut
  status: 200
}

export type listResidentsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listResidentsResponseSuccess = (listResidentsResponse200) & {
  headers: Headers;
};
export type listResidentsResponseError = (listResidentsResponse422) & {
  headers: Headers;
};

export type listResidentsResponse = (listResidentsResponseSuccess | listResidentsResponseError)

export const getListResidentsUrl = (params?: ListResidentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/residents?${stringifiedParams}` : `/api/residents`
}

/**
 * @summary List Residents
 */
export const listResidents = async (params?: ListResidentsParams, options?: Parameters<typeof apiFetch>[1]): Promise<listResidentsResponse> => {

  return apiFetch<listResidentsResponse>(getListResidentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListResidentsQueryKey = (params?: ListResidentsParams,) => {
    return [
    `/api/residents`, ...(params ? [params] : [])
    ] as const;
    }


export const getListResidentsQueryOptions = <TData = Awaited<ReturnType<typeof listResidents>>, TError = HTTPValidationError>(params?: ListResidentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listResidents>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListResidentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listResidents>>> = ({ signal }) => listResidents(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listResidents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListResidentsQueryResult = NonNullable<Awaited<ReturnType<typeof listResidents>>>
export type ListResidentsQueryError = HTTPValidationError


export function useListResidents<TData = Awaited<ReturnType<typeof listResidents>>, TError = HTTPValidationError>(
 params: undefined |  ListResidentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listResidents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listResidents>>,
          TError,
          Awaited<ReturnType<typeof listResidents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListResidents<TData = Awaited<ReturnType<typeof listResidents>>, TError = HTTPValidationError>(
 params?: ListResidentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listResidents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listResidents>>,
          TError,
          Awaited<ReturnType<typeof listResidents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListResidents<TData = Awaited<ReturnType<typeof listResidents>>, TError = HTTPValidationError>(
 params?: ListResidentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listResidents>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Residents
 */

export function useListResidents<TData = Awaited<ReturnType<typeof listResidents>>, TError = HTTPValidationError>(
 params?: ListResidentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listResidents>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListResidentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createResidentResponse201 = {
  data: ResidentOut
  status: 201
}

export type createResidentResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createResidentResponseSuccess = (createResidentResponse201) & {
  headers: Headers;
};
export type createResidentResponseError = (createResidentResponse422) & {
  headers: Headers;
};

export type createResidentResponse = (createResidentResponseSuccess | createResidentResponseError)

export const getCreateResidentUrl = () => {




  return `/api/residents`
}

/**
 * @summary Create Resident
 */
export const createResident = async (residentIn: ResidentIn, options?: Parameters<typeof apiFetch>[1]): Promise<createResidentResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<createResidentResponse>(getCreateResidentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(residentIn)
  }
);}





export const getCreateResidentMutationKey = () => ['createResident'] as const;

export const getCreateResidentMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResident>>, TError,CreateResidentMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createResident>>, TError,CreateResidentMutationVariables, TContext> => {

const mutationKey = getCreateResidentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createResident>>, CreateResidentMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createResident(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateResidentMutationResult = NonNullable<Awaited<ReturnType<typeof createResident>>>
    export type CreateResidentMutationBody = ResidentIn
    export type CreateResidentMutationError = HTTPValidationError
    export type CreateResidentMutationVariables = {data: ResidentIn}

    /**
 * @summary Create Resident
 */
export const useCreateResident = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResident>>, TError,CreateResidentMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createResident>>,
        TError,
        CreateResidentMutationVariables,
        TContext
      > => {
      return useMutation(getCreateResidentMutationOptions(options), queryClient);
    }
    export type inviteResidentToPortalResponse200 = {
  data: InvitationCreatedOut
  status: 200
}

export type inviteResidentToPortalResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type inviteResidentToPortalResponseSuccess = (inviteResidentToPortalResponse200) & {
  headers: Headers;
};
export type inviteResidentToPortalResponseError = (inviteResidentToPortalResponse422) & {
  headers: Headers;
};

export type inviteResidentToPortalResponse = (inviteResidentToPortalResponseSuccess | inviteResidentToPortalResponseError)

export const getInviteResidentToPortalUrl = (residentId: number,) => {




  return `/api/residents/${residentId}/portal-invite`
}

/**
 * @summary Invite Resident To Portal
 */
export const inviteResidentToPortal = async (residentId: number, options?: Parameters<typeof apiFetch>[1]): Promise<inviteResidentToPortalResponse> => {

  return apiFetch<inviteResidentToPortalResponse>(getInviteResidentToPortalUrl(residentId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getInviteResidentToPortalMutationKey = () => ['inviteResidentToPortal'] as const;

export const getInviteResidentToPortalMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteResidentToPortal>>, TError,InviteResidentToPortalMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof inviteResidentToPortal>>, TError,InviteResidentToPortalMutationVariables, TContext> => {

const mutationKey = getInviteResidentToPortalMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inviteResidentToPortal>>, InviteResidentToPortalMutationVariables> = (props) => {
          const {residentId} = props ?? {};

          return  inviteResidentToPortal(residentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InviteResidentToPortalMutationResult = NonNullable<Awaited<ReturnType<typeof inviteResidentToPortal>>>

    export type InviteResidentToPortalMutationError = HTTPValidationError
    export type InviteResidentToPortalMutationVariables = {residentId: number}

    /**
 * @summary Invite Resident To Portal
 */
export const useInviteResidentToPortal = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteResidentToPortal>>, TError,InviteResidentToPortalMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inviteResidentToPortal>>,
        TError,
        InviteResidentToPortalMutationVariables,
        TContext
      > => {
      return useMutation(getInviteResidentToPortalMutationOptions(options), queryClient);
    }
    export type removeResidentPortalAccessResponse204 = {
  data: void
  status: 204
}

export type removeResidentPortalAccessResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type removeResidentPortalAccessResponseSuccess = (removeResidentPortalAccessResponse204) & {
  headers: Headers;
};
export type removeResidentPortalAccessResponseError = (removeResidentPortalAccessResponse422) & {
  headers: Headers;
};

export type removeResidentPortalAccessResponse = (removeResidentPortalAccessResponseSuccess | removeResidentPortalAccessResponseError)

export const getRemoveResidentPortalAccessUrl = (residentId: number,) => {




  return `/api/residents/${residentId}/portal-access`
}

/**
 * @summary Remove Resident Portal Access
 */
export const removeResidentPortalAccess = async (residentId: number, options?: Parameters<typeof apiFetch>[1]): Promise<removeResidentPortalAccessResponse> => {

  return apiFetch<removeResidentPortalAccessResponse>(getRemoveResidentPortalAccessUrl(residentId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveResidentPortalAccessMutationKey = () => ['removeResidentPortalAccess'] as const;

export const getRemoveResidentPortalAccessMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeResidentPortalAccess>>, TError,RemoveResidentPortalAccessMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeResidentPortalAccess>>, TError,RemoveResidentPortalAccessMutationVariables, TContext> => {

const mutationKey = getRemoveResidentPortalAccessMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeResidentPortalAccess>>, RemoveResidentPortalAccessMutationVariables> = (props) => {
          const {residentId} = props ?? {};

          return  removeResidentPortalAccess(residentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveResidentPortalAccessMutationResult = NonNullable<Awaited<ReturnType<typeof removeResidentPortalAccess>>>

    export type RemoveResidentPortalAccessMutationError = HTTPValidationError
    export type RemoveResidentPortalAccessMutationVariables = {residentId: number}

    /**
 * @summary Remove Resident Portal Access
 */
export const useRemoveResidentPortalAccess = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeResidentPortalAccess>>, TError,RemoveResidentPortalAccessMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeResidentPortalAccess>>,
        TError,
        RemoveResidentPortalAccessMutationVariables,
        TContext
      > => {
      return useMutation(getRemoveResidentPortalAccessMutationOptions(options), queryClient);
    }
    export type getResidentResponse200 = {
  data: ResidentOut
  status: 200
}

export type getResidentResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getResidentResponseSuccess = (getResidentResponse200) & {
  headers: Headers;
};
export type getResidentResponseError = (getResidentResponse422) & {
  headers: Headers;
};

export type getResidentResponse = (getResidentResponseSuccess | getResidentResponseError)

export const getGetResidentUrl = (recordId: number,) => {




  return `/api/residents/${recordId}`
}

/**
 * @summary Get Resident
 */
export const getResident = async (recordId: number, options?: Parameters<typeof apiFetch>[1]): Promise<getResidentResponse> => {

  return apiFetch<getResidentResponse>(getGetResidentUrl(recordId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetResidentQueryKey = (recordId: number,) => {
    return [
    `/api/residents/${recordId}`
    ] as const;
    }


export const getGetResidentQueryOptions = <TData = Awaited<ReturnType<typeof getResident>>, TError = HTTPValidationError>(recordId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResident>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResidentQueryKey(recordId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResident>>> = ({ signal }) => getResident(recordId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: recordId !== null && recordId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResident>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetResidentQueryResult = NonNullable<Awaited<ReturnType<typeof getResident>>>
export type GetResidentQueryError = HTTPValidationError


export function useGetResident<TData = Awaited<ReturnType<typeof getResident>>, TError = HTTPValidationError>(
 recordId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResident>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResident>>,
          TError,
          Awaited<ReturnType<typeof getResident>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResident<TData = Awaited<ReturnType<typeof getResident>>, TError = HTTPValidationError>(
 recordId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResident>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResident>>,
          TError,
          Awaited<ReturnType<typeof getResident>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResident<TData = Awaited<ReturnType<typeof getResident>>, TError = HTTPValidationError>(
 recordId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResident>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Resident
 */

export function useGetResident<TData = Awaited<ReturnType<typeof getResident>>, TError = HTTPValidationError>(
 recordId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResident>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResidentQueryOptions(recordId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type updateResidentResponse200 = {
  data: ResidentOut
  status: 200
}

export type updateResidentResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type updateResidentResponseSuccess = (updateResidentResponse200) & {
  headers: Headers;
};
export type updateResidentResponseError = (updateResidentResponse422) & {
  headers: Headers;
};

export type updateResidentResponse = (updateResidentResponseSuccess | updateResidentResponseError)

export const getUpdateResidentUrl = (recordId: number,) => {




  return `/api/residents/${recordId}`
}

/**
 * @summary Update Resident
 */
export const updateResident = async (recordId: number,
    residentIn: ResidentIn, options?: Parameters<typeof apiFetch>[1]): Promise<updateResidentResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<updateResidentResponse>(getUpdateResidentUrl(recordId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(residentIn)
  }
);}





export const getUpdateResidentMutationKey = () => ['updateResident'] as const;

export const getUpdateResidentMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateResident>>, TError,UpdateResidentMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateResident>>, TError,UpdateResidentMutationVariables, TContext> => {

const mutationKey = getUpdateResidentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateResident>>, UpdateResidentMutationVariables> = (props) => {
          const {recordId,data} = props ?? {};

          return  updateResident(recordId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateResidentMutationResult = NonNullable<Awaited<ReturnType<typeof updateResident>>>
    export type UpdateResidentMutationBody = ResidentIn
    export type UpdateResidentMutationError = HTTPValidationError
    export type UpdateResidentMutationVariables = {recordId: number;data: ResidentIn}

    /**
 * @summary Update Resident
 */
export const useUpdateResident = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateResident>>, TError,UpdateResidentMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateResident>>,
        TError,
        UpdateResidentMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateResidentMutationOptions(options), queryClient);
    }
    export type deleteResidentResponse204 = {
  data: void
  status: 204
}

export type deleteResidentResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type deleteResidentResponseSuccess = (deleteResidentResponse204) & {
  headers: Headers;
};
export type deleteResidentResponseError = (deleteResidentResponse422) & {
  headers: Headers;
};

export type deleteResidentResponse = (deleteResidentResponseSuccess | deleteResidentResponseError)

export const getDeleteResidentUrl = (recordId: number,) => {




  return `/api/residents/${recordId}`
}

/**
 * @summary Delete Resident
 */
export const deleteResident = async (recordId: number, options?: Parameters<typeof apiFetch>[1]): Promise<deleteResidentResponse> => {

  return apiFetch<deleteResidentResponse>(getDeleteResidentUrl(recordId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteResidentMutationKey = () => ['deleteResident'] as const;

export const getDeleteResidentMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteResident>>, TError,DeleteResidentMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteResident>>, TError,DeleteResidentMutationVariables, TContext> => {

const mutationKey = getDeleteResidentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteResident>>, DeleteResidentMutationVariables> = (props) => {
          const {recordId} = props ?? {};

          return  deleteResident(recordId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteResidentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteResident>>>

    export type DeleteResidentMutationError = HTTPValidationError
    export type DeleteResidentMutationVariables = {recordId: number}

    /**
 * @summary Delete Resident
 */
export const useDeleteResident = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteResident>>, TError,DeleteResidentMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteResident>>,
        TError,
        DeleteResidentMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteResidentMutationOptions(options), queryClient);
    }
